import React from 'react';
import Groups from 'containers/Organizations/SingleOrganization/Groups/GroupList';

export default {
  name: 'groups',
  path: /.*\/organizations\/\d+\/agents\/\d+\/groups$/,
  component: <Groups agentGroups />,
};
